/** @jsx jsx */
import { jsx } from '@emotion/react';

import logger from 'js/app/loggerSingleton';

import DomainListComponent from 'bundles/page-config-common/components/shared/DomainListComponent';
import { useDomainList } from 'bundles/page-config-common/contexts/DomainListContext';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import type { PageConfig_BrowseDomainListComponentMetadataFragment as BrowseDomainListComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfig_CollectionComponentMetadata';

type Props = {
  pageConfig: BrowseDomainListComponent;
};

const DomainListRenderer = (props: Props) => {
  const domainListContext = useDomainList();
  const pageConfigComponentMetadataContext = usePageConfigComponentMetadata();

  if (!domainListContext) {
    logger.warn('DomainListRenderer expected DomainListProvider');
    return null;
  }
  if (!pageConfigComponentMetadataContext) {
    logger.warn('DomainListRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  const {
    pageConfig: { sectionTitle: title },
  } = props;
  const { domains = [] } = domainListContext;
  const { index } = pageConfigComponentMetadataContext;

  return <DomainListComponent title={title} domains={domains} showPageTitleHeadingSize={index === 0} />;
};

export default DomainListRenderer;
